var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-dialog",
    {
      attrs: { visible: _vm.visible, "is-small-title": _vm.isSmallTitle },
      on: { close: _vm.close },
    },
    [
      !_vm.success
        ? _c("template", { slot: "title" }, [
            _vm._v(
              " " + _vm._s(_vm.title ? _vm.title : "Прописка уже скоро!") + " "
            ),
          ])
        : _vm._e(),
      _vm.success
        ? _c(
            "div",
            {
              staticClass: "subscribe-modal",
              attrs: { slot: "content" },
              slot: "content",
            },
            [_c("modal-success", { on: { close: _vm.close } })],
            1
          )
        : _vm._e(),
      !_vm.success
        ? _c(
            "div",
            {
              staticClass: "subscribe-modal",
              attrs: { slot: "content", id: _vm.idModal },
              slot: "content",
            },
            [
              _c("div", { staticClass: "subscribe-modal__desc" }, [
                _vm._v(
                  " " + _vm._s(_vm.description ? _vm.description : "") + " "
                ),
              ]),
              _c(
                "form",
                {
                  ref: "subscribe-form",
                  staticClass: "subscribe-modal__form subscribe-form",
                  attrs: { id: _vm.id, method: "POST" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "subscribe-form__row" }, [
                    _c(
                      "div",
                      { staticClass: "subscribe-form__col" },
                      [
                        _c("ui-input", {
                          ref: "form-name",
                          attrs: {
                            id: _vm.id + "-name",
                            "placeholder-value": "Имя",
                            hint: "Введите корректные данные",
                            type: "text",
                            "placeholder-white": "",
                            required: "",
                          },
                          model: {
                            value: _vm.name,
                            callback: function ($$v) {
                              _vm.name = $$v
                            },
                            expression: "name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "subscribe-form__col" },
                      [
                        _c("ui-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "+7 (###) ###-##-##",
                              expression: "'+7 (###) ###-##-##'",
                            },
                          ],
                          ref: "form-phone",
                          attrs: {
                            id: _vm.id + "-phone",
                            type: "tel",
                            hint: "Введите корректный номер телефона",
                            "placeholder-value": "телефон",
                            "placeholder-white": "",
                            required: "",
                          },
                          model: {
                            value: _vm.phone,
                            callback: function ($$v) {
                              _vm.phone = $$v
                            },
                            expression: "phone",
                          },
                        }),
                        !_vm.isPhoneValid
                          ? _c("div", { staticClass: "form-phone_valid" }, [
                              _vm._v(" Введите корректный номер телефона "),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "subscribe-form__row" },
                    [
                      _c(
                        "ui-button",
                        {
                          attrs: { type: "submit" },
                          on: { click: _vm.submitForm },
                        },
                        [_vm._v(" " + _vm._s(_vm.buttonName) + " ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "subscribe-form__row" },
                    [
                      _c("ui-input", {
                        ref: "form-agreement",
                        staticClass: "row",
                        attrs: {
                          id: _vm.id + "-agreement",
                          type: "checkbox",
                          dark: "",
                          required: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _c(
                                    "span",
                                    [
                                      _vm._v(
                                        "Нажимая кнопку «Отправить», я соглашаюсь с политикой обработки "
                                      ),
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { name: "UserAgreementPage" },
                                            target: "_blank",
                                          },
                                        },
                                        [_vm._v("персональных данных")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3188345207
                        ),
                        model: {
                          value: _vm.checkbox,
                          callback: function ($$v) {
                            _vm.checkbox = $$v
                          },
                          expression: "checkbox",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }